import { useState, useEffect } from "react";
import { IMapCenter } from "src/share/types/common";

interface IGeoLocationState {
  address: string;
  isSelected: boolean;
  center?: IMapCenter;
  radius: number;
}

export const initialGeolocation = { address: "",  center: undefined, isSelected: false, radius: 1 };

export default function useGeolocation(routeState) {
  const [geolocation, setGeolocation] = useState<IGeoLocationState>(initialGeolocation);
  useEffect(() => {
    if (geolocation.center && routeState) {
      setGeolocation(prevState => ({ ...prevState, isSelected: true }));
    }
  }, [geolocation.center]);
  return {
    geolocation,
    setGeolocation
  };
}


// WEBPACK FOOTER //
// ./src/modules/GeoSearch/ManualSearch/hooks/useGeolocation.ts